/*!
 * React FormControl Library v3.6.0 for FormEngine
 * 
 * Copyright Gars Infotech Private Limited / Xio Infotech Private Limited Foundation and other contributors
 * Released under the MIT license
 * 
 * 
 * Date: 2022-03-02T17:08Z
 * Copyright (c) <2022> <Xio Infotech Private Limited>
 * The MIT License is not the only permissive license. Other well-known permissive licenses include: Apache 2.0, BSD.
 */
import * as React from 'react';
// import useStyles from '../Component/Theme_1/FormControlsCss';
import ThemeControls from "../Component/AllThemesControl";
import {useState} from 'react';

export default function TextContent(props){
    const {useStyle} = ThemeControls;
    const classes = useStyle();
    const { field_type, field_id, field_label, field_placeholder, field_value, field_options,field_helperText,field_minlength,field_maxlength,field_maxvalue,field_value_type,field_minvalue,field_error_msg_required,field_error_msg_minlength,field_error_msg_maxlength,field_error_msg_minvalue,field_error_msg_maxvalue,field_error_msg_uq,field_mandatory } = props;
    //for this compoent there is no need for validation just the field_value is required. 
    if(field_value&&field_value!==""){
        //console.log(field_value)
    return(
        
    <div className={classes.timeInputGrp}>
        <h2>{String(field_value)}</h2>
    </div>
    )}else{
        return null
    }
}